import React from 'react'
import { LogoutUser } from '../../../../../util/authUtils';

const HeaderLogout = ({ label = '', onLogout = false, cssClass = '' }) => {

    const handleLogout = () => {
        LogoutUser();
        if (onLogout) {
            onLogout();
        }
        // Moved the page reload logic to logout function - to have more control over the logout behavior
    }
    return (
        <div className={`${cssClass}`} onClick={handleLogout}>
            {label}
        </div>
    )
}

export default HeaderLogout
